import { render, staticRenderFns } from "./recycle.vue?vue&type=template&id=eeff0fde&scoped=true"
import script from "./recycle.vue?vue&type=script&lang=js"
export * from "./recycle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeff0fde",
  null
  
)

export default component.exports